import {RouterModule, Routes} from '@angular/router';

import {CmsComponent} from './cms.component';
import {ModuleWithProviders} from '@angular/core';
import {CmsModule} from './cms.module';
import { TopListComponent } from './top-list/top-list.component';
import { MamPammFollowerComponent } from './mam-pamm-follower/mam-pamm-follower.component';
import { TraderComponent } from './trader/trader.component';
import { IBComponent } from './ib/ib.component';
import { CmsDetailComponent } from './cms-detail/cms-detail.component';

// noinspection TypeScriptValidateTypes
export const routes: Routes = [
  {
    path: '',
    component: CmsComponent,
    children: [
      {
        path: '', component: TopListComponent,
        children: [
          {
            path: 'detail',
            component: CmsDetailComponent
          }
        ]
      },
      {
        path: 'trader', component: TraderComponent
      },
      {
        path: 'ib', component: IBComponent
      },
      {
        path: 'mam-pamm-follower', component: MamPammFollowerComponent
      },

    ]
  },
];

export const routing: ModuleWithProviders<CmsModule> = RouterModule.forChild(routes);
